<template>
  <b-form-group
    label="İlçe"
    label-for="districts"
  >
    <validation-provider
      #default="{ errors }"
      name="İlçe"
      rules=""
    >
      <b-form-input
        id="districts"
        v-model="itemData.districts"
        placeholder="İlçe"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'DistrictsText',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['products/dataItem']
    },
  },
}
</script>
